import type { PropsWithChildren } from "react";

import { styled } from "@linaria/react";

import { withTheme } from "../theme/GalaxyTheme";
import type { PropsWithTheme } from "../theme/types";

const StyledBoldText = withTheme(styled.span<PropsWithTheme>`
  font-weight: ${({ theme }) => theme.font.sans.weight.medium};
`);

const Bold = ({ children }: PropsWithChildren) => {
  return <StyledBoldText>{children}</StyledBoldText>;
};

export default Bold;
